import { ModalAction } from '@overlayqa/shared/ui';
import { capture } from '@/lib/analytics';
import { IntegrationCardShell } from './IntegrationCard';
import { BrandTile, type BrandMark } from './integrationLogos';

interface ToolIntegrationCardProps {
  /** The analytics id ('claude-code', 'zapier'). */
  provider: string;
  mark: BrandMark;
  name: string;
  description: string;
  onSetUp: () => void;
  testId: string;
}

/**
 * A tool card in the /integrations grid: the provider cards' shell with Set up in the header. The card itself opens
 * the same setup dialog, as a provider card opens its details (integration_card_opened, status 'setup').
 */
export function ToolIntegrationCard({ provider, mark, name, description, onSetUp, testId }: ToolIntegrationCardProps) {
  return (
    <IntegrationCardShell
      testId={testId}
      tile={<BrandTile mark={mark} />}
      right={
        <button type="button" className="btn-secondary text-sm" onClick={onSetUp}>
          <ModalAction kind="link">Set up</ModalAction>
        </button>
      }
      name={name}
      description={description}
      descriptionId={`integration-${provider}-description`}
      onOpen={() => {
        capture('integration_card_opened', { provider, status: 'setup' });
        onSetUp();
      }}
    />
  );
}
